import styled from 'styled-components';
import LanguageSelect from './LanguageSelect';
import { media } from 'utils/style';

export default styled(LanguageSelect)`
  display: flex;
  justify-content: flex-start;
  width: 100%;

  ${media.greaterThan('tablet')`
    justify-content: flex-end;
  `}

  .language-select {
    display: flex;
    width: 284px;

    &__loading {
      .spinner {
        height: 24px;
        width: 24px;
      }
    }
  }
`;
